const paths = {
  editPartner: '/partner/edit',
  webServiceRates: '/partner/rates',
  newComponents: '/partner/new-components',
  publicReferencesMap: '/partner/references',
  teamActions: '/partner/device-actions'
};

export default paths;
